import { AvatarSkeletonComponent } from './avatar-skeleton.component';

export default angular
  .module('sfMobile.components.avatar-skeleton', [])
  .component('sfAvatarSkeleton', AvatarSkeletonComponent).name;
